<template>
    <el-row class="reFormResult">
        <el-row class="statusForm">
            <el-steps  :active="1" finish-status="success">
                <el-step title="填写问题信息"></el-step>
                <el-step title="等待相关人员回复"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>
        </el-row>
        <el-row>
            <el-col :sm="24" :lg="24">
                <el-result icon="success" title="操作成功" subTitle="等待相关人员处理">
                  <template slot="extra">
                    <el-row class="colcol">
                        <el-col :span="24"><div class="">标题：{{ formData.title }}</div></el-col>
                        <el-col :span="24"><div class="">处理部门：{{ formData.goods_category_name }}</div></el-col>
                    </el-row>
                    <el-button type="primary" size="medium" @click="goDetail">查看详情</el-button>
                    <el-button type='default' size="medium" @click="bnackHome">返回首页</el-button>
                  </template>
                </el-result>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
        formData:{}
    };
  },
  watch: {},
  computed: {},
  methods: {
    goDetail(){
        this.$router.push('/orderDetail/orderDetail?jumpId='+ (this.formData.id))
    },
    bnackHome(){
        this.$router.go(-3)
    }
  },
  created() {},
  mounted() {
  },
  activated(){
    this.formData = this.$route.params.data
    console.log(this.formData,'this.formData');
  }
};
</script>
<style lang="scss" scoped>
.reFormResult{
    padding:10px 20px;
    background: #ffffff;
    box-sizing: border-box;
    .statusForm{
       padding: 0 50px;
    }
}
.colcol{
    margin: 20px 0;
    line-height: 30px;
}
</style>